import RouterLink from '@app/components/RouterLink';
import DevText from '@app/components/Text';
import { Card, Colors } from '@blueprintjs/core';
import React from 'react';
import {
    NotificationResource,
    SubscriptionResource,
    SubscriptionPauseScheduleActivatedActivityPayloadResource,
} from 'dy-frontend-http-repository/lib/modules/Notification/resources';
import { Endpoints } from '@app/data/consts';
import NotificationTemplate from '../../../../NotificationTemplate';
import moment from 'moment';

export interface SubscriptionPauseScheduleActivatedNotificationProps {
    authorizedUserId: ID;
    notification: NotificationResource;
    subscription: SubscriptionResource | null;
    dismiss: () => Promise<void>;
}

type Props = SubscriptionPauseScheduleActivatedNotificationProps;

// TODO: output
const amountOfSecondsInDay = 86400;

const SubscriptionPauseScheduleActivatedNotification: React.FC<Props> = ({ notification, subscription, dismiss }) => {
    const renderContent = () => {
        if (!subscription) {
            // This is bad, subscription is NOT found, which should not happen
            return <DevText color={Colors.RED2}>Subscription was not found</DevText>;
        }

        const payload: SubscriptionPauseScheduleActivatedActivityPayloadResource | null = notification.activity.payload;
        if (!payload) {
            // This is bad, there should be payload, but for some reason it is not there
            return <DevText color={Colors.RED2}>Payload was not found</DevText>;
        }

        return (
            <div>
                <DevText running className="mb-1">
                    <RouterLink to={Endpoints.SUBSCRIPTION.replace(':subscriptionId', subscription.id)}>
                        Subscription
                    </RouterLink>{' '}
                    of{' '}
                    <RouterLink to={Endpoints.CLIENT_BILLING.replace(':clientId', subscription.user.id)}>
                        {subscription.user.first_name} {subscription.user.last_name}
                    </RouterLink>{' '}
                    was paused with following resume schedule:
                </DevText>

                <Card compact>
                    <DevText className="mb-small">
                        <DevText inline muted>
                            Resume at:
                        </DevText>{' '}
                        {moment(payload.release_scheduled_at).format('D MMM YYYY, HH:mm')}
                    </DevText>
                    <DevText>
                        <DevText inline muted>
                            Add after resume:
                        </DevText>{' '}
                        {Math.round(payload.unused_period / amountOfSecondsInDay)} days
                    </DevText>
                </Card>
            </div>
        );
    };

    return (
        <NotificationTemplate
            title="Subscription paused using pause schedule"
            icon="pause"
            at={notification.activity.at}
            content={renderContent()}
            dismiss={dismiss}
        />
    );
};

export default SubscriptionPauseScheduleActivatedNotification;
